import "./OfferRequests.css";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useBetween } from "use-between";
import { getTranslatedText as translate } from "../../Localization/Translation";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import DetailedOffer from "./DetailedOffer/DetailedOffer.js";

const OfferRequests = () => {
  const { locale } = useBetween(useSelector((state) => state.useSharedLang));
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = (laundryId) => {
    setShow(true);
  };
  const acceptReq = (id) => {
    document.getElementById(id).style.display = "none";
  };
  const rejectReq = (id) => {
    document.getElementById(id).style.display = "none";
  };

  var LaundryOffersRequests = [
    {
      id: 1,
      name: "مغسلة السعودية",
      date: "25/12/2020",
      Address: "الرياض",
    },
    {
      id: 2,
      name: "مغسلة السعودية",
      date: "25/12/2020",
      Address: "الرياض",
    },
    {
      id: 3,
      name: "مغسلة السعودية",
      date: "25/12/2020",
      Address: "الرياض",
    },
    {
      id: 4,
      name: "مغسلة السعودية",
      date: "25/12/2020",
      Address: "الرياض",
    },
  ];
  let d = "-1";
  var LaundryOffersRequestsList = LaundryOffersRequests.map((Req) => {
    d = Number(d) + 1;
    return (
      <div
        className={
          "request-card row animate__animated animate__fadeInUp animate__delay-" +
          d +
          "s"
        }
        dir="auto"
        key={Req.id}
        id={Req.id}
      >
        <div
          className="col-md-5 request-card-col main-data-request-card-col"
          dir="auto"
        >
          <div className="header-join-req-card">
            <i className="fa fa-building" aria-hidden="true"></i>
            <span>{translate("laundry-name", locale)}:</span>
            <span>{Req.name}</span>
          </div>
          <div className="date-join-req-card">
            <i className="fa fa-calendar" aria-hidden="true"></i>
            <span>{translate("date-of-request", locale)}:</span>
            <span>{Req.date}</span>
          </div>
        </div>
        <div className="col-md request-card-col detail-btn-request-card-col">
          <button className="btn btn-primary" onClick={handleShow}>
            {translate("offer-det-btn", locale)}
          </button>
        </div>
        <div className="col request-card-col approval-request-card-col">
          <button className="btn btn-primary" onClick={() => acceptReq(Req.id)}>
            <i className="fa fa-check" aria-hidden="true"></i>
            {translate("accept-request", locale)}
          </button>
          <button
            className="btn btn-secondary"
            onClick={() => rejectReq(Req.id)}
          >
            <i className="fa fa-times" aria-hidden="true"></i>
            {translate("reject-request", locale)}
          </button>
        </div>
      </div>
    );
  });

  return (
    <div className="DeliveryJoinReq-component">
      {LaundryOffersRequestsList}

      <Modal show={show} onHide={handleClose} size="md" dir="auto">
        <Modal.Header className="modal-header">
          {translate("offer-det-btn", locale)}
        </Modal.Header>
        <Modal.Body>
          <DetailedOffer />
        </Modal.Body>
        <Modal.Footer dir="auto">
          <Button variant="secondary" onClick={handleClose}>
            {translate("modal-close-btn", locale)}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default OfferRequests;
